module.exports = __webpack_public_path__ + "img/phishing.c517c87d.png";